// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.p-rating {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\n}\n.p-rating-item {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    cursor: pointer;\n}\n.p-rating.p-readonly .p-rating-item {\r\n    cursor: default;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
